import { useKyvEnabled } from "@/hooks";
import { FindVehicleModal } from "../AddVehicleV3/FindVehicleModal";
import { AddVehicleModal } from "./modals/AddVehicleModal";

interface AddVehicleEntryProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Chooses the add-vehicle front door.
 *
 * With KYV on, it is Find (DEV-1889): plate + state, then the five-step page —
 * documents, walk-around, details, drivers, and Review, where the vehicle is
 * created and its fee charged. Nothing partial exists as a vehicle if the
 * operator walks away mid-flow; the verification is a draft until then. With
 * KYV off, it is the plate registry lookup — the AU flow, unchanged.
 *
 * See useKyvEnabled for who gets which. Short version: outside Australia KYV
 * is the only path that can work, so it is not negotiable there; inside
 * Australia the flag decides and defaults to the plate flow.
 */
export const AddVehicleEntry = ({ open, onClose }: AddVehicleEntryProps) => {
  const { enabled: kyvEnabled, isLoading: loadingKyv } = useKyvEnabled();

  // Render neither door until we know which one this operator has. Guessing
  // costs more than a flicker here: Find would be the wrong question for an
  // operator who is about to be handed the plate lookup.
  if (loadingKyv) return null;

  if (!kyvEnabled) {
    return <AddVehicleModal open={open} onClose={onClose} />;
  }

  return <FindVehicleModal open={open} onClose={onClose} />;
};
